import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import BalanceInputs from '../../NestedInputs/BalanceInputs';

export default function VariableAssets({ assets, viewOnly }) {
  const dispatch = useDispatch();
  const { values, errors } = useFormikContext();
  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Rentas Variables</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ marginBottom: 10, textAlign: 'center' }}>
          <BalanceInputs
            isVariable
            variable="settlement"
            subVariable="variableAssets"
            dispatch={dispatch}
            balanceType="asset"
            extraValueProps={{
              variable: 'variable',
              settlement_base: 'prior_notice_compensation'
            }}
            assets={[...assets.variableAssets]}
            discounts={[]}
            allValuesAttributes={values?.settlement?.variableAssets || []}
            createOnClick={!viewOnly && values?.settlement?.variableIncome === 'true'}
            canCreate={!viewOnly && values?.settlement?.variableIncome === 'true'}
            canDestroy={!viewOnly}
          />
        </Col>
        <Col xl={12} xs={12} md={12} lg={12} style={{ marginBottom: 10, textAlign: 'center' }}>
          {typeof errors.settlement?.variableAssets === 'string' && (
            <Form.Text className="text-danger">
              <strong>{errors.settlement.variableAssets}</strong>
            </Form.Text>
          )}
        </Col>
      </Row>
    </>
  );
}
